export const groupsPageEmptyHeaderCopy = 'There are no groups created for this location yet.';

export const groupsPageEmptyBodyCopy =
  'You can create custom groups of team members to manage your team schedules.';
